import ShantoITInvoiceHandler from "../../services/ShantoITInvoice";

export default {
    async loadShantoITInvoices({commit, dispatch}, payload) {
        const {data} = await ShantoITInvoiceHandler.all(payload);

        commit('SET_SHANTO_IT_INVOICE', data);
    }
}
